export default {
  install(Vue) {
    Vue.prototype.$app = {
      // Retorna o nome do sport a partir do ID
      nameSport: function (idSport) {
        const nameSport = {
          6046: "Futebol",
          48242: "Basquete",
          54094: "Tênis",
          154919: "UFC/Boxe",
          687890: "E-Sports"
        }
        return nameSport[idSport]
      },
      
      // Retorna o icon a partir do ID
      icon : function (id) {
        const icons = {
          6046: "mdi-soccer",
          54094: "mdi-tennis-ball",
          154919: "mdi-boxing-glove",
          48242: "mdi-basketball",
          154914: "mdi-baseball",
          154830: "mdi-volleyball",
          10: "mdi-trophy-award",
          687890: "mdi-gamepad-variant-outline"
        }

        return icons[id]
      }
    } 
  }
}